module.exports = __webpack_public_path__ + "static/fanny_0-494a9ca32bef970c777825726a298661.jpg";